import { bus } from '@/utils/bus';
import BaseModal from './baseModal';

class SucBaseModal extends BaseModal {
//   constructor(showClose, mes, duration) {
//     super(showClose, mes, duration);
//   }

  showMsg() {
    return bus.$message.success({
      showClose: this.showClose,
      message: this.mes.toString(),
      duration: this.duration,
    });
  }

  showNotifyMsg() {
    return bus.$notify({
      title: '成功',
      message: this.mes,
      type: 'success',
    });
  }
}

export default SucBaseModal;
